(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("text-encoding"));
	else if(typeof define === 'function' && define.amd)
		define("Zxing", ["text-encoding"], factory);
	else if(typeof exports === 'object')
		exports["Zxing"] = factory(require("text-encoding"));
	else
		root["Zxing"] = factory(root["text-encoding"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_36__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition